import { render, staticRenderFns } from "./Layer.vue?vue&type=template&id=ec7e5f5a&scoped=true&"
import script from "./Layer.vue?vue&type=script&lang=js&"
export * from "./Layer.vue?vue&type=script&lang=js&"
import style0 from "./Layer.vue?vue&type=style&index=0&id=ec7e5f5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec7e5f5a",
  null
  
)

export default component.exports